import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";

type CustomErrorType = { message: string };
const baseQuery = fakeBaseQuery<CustomErrorType>();

export const firebaseApiWrapper = createApi({
  baseQuery,
  keepUnusedDataFor: 5,
  tagTypes: [
    "Conversations",
    "Documents",
    "Plans",
    "Apps",
    "Accounts",
    "Subscription",
    "Transcriptions",
    "Summaries",
    "AgentTuning",
    "Legal",
    "SpeakerIdentifications",
  ],
  endpoints: () => ({}),
});
